import src from "IMAGE";
export default { src, width: 85, height: 22, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ABIcSDEKDygbGidqRRciXT8IDSMXFSBYPBsnbEwbKGtPABspblEkNY5rGyhsTBsobU0lN5VvIC9+WyEwgWgpO6B/p70PakLNgAMAAAAASUVORK5CYII="};
